import { useState } from "react";
import { toast } from "sonner";
import { Check, ChevronDown, Copy, ExternalLink, Link2 } from "lucide-react";

// Tombol "Tautan" di pojok kanan bawah kartu: menyalin / membuka URL PUBLIK
// (tanpa login, hanya lihat) yang hanya menampilkan isian kartu ini saja.
export const kartuUrl = (code, year) =>
  `${window.location.origin}/monev/${encodeURIComponent(code)}?tahun=${year}`;

export default function TautanDropdown({ code, year }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = kartuUrl(code, year);

  const salin = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Tautan kartu disalin");
    setTimeout(() => setCopied(false), 1500);
    setOpen(false);
  };

  const buka = () => {
    window.open(url, "_blank", "noopener");
    setOpen(false);
  };

  return (
    <div className="relative" data-testid={`monev-tautan-${code}`}>
      <button
        type="button"
        data-testid={`monev-tautan-trigger-${code}`}
        title="Tautan ke halaman kartu ini saja"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 rounded-full border border-[#E3EBF3] px-3 py-1 text-[10px] font-bold text-slate-500 transition-colors duration-200 hover:bg-[#EFF6FC] hover:text-[#1479BF]"
      >
        <Link2 aria-hidden="true" className="h-3 w-3" />
        Tautan
        <ChevronDown
          aria-hidden="true"
          className={`h-3 w-3 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute bottom-full right-0 z-50 mb-2 w-44 rounded-2xl border border-[#E3EBF3] bg-white p-2 shadow-xl">
            <button
              type="button"
              data-testid={`monev-tautan-salin-${code}`}
              onClick={salin}
              className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-xs font-semibold text-slate-600 transition-colors duration-150 hover:bg-[#F3F7FB] hover:text-[#1479BF]"
            >
              {copied ? (
                <Check aria-hidden="true" className="h-3.5 w-3.5 text-emerald-500" />
              ) : (
                <Copy aria-hidden="true" className="h-3.5 w-3.5" />
              )}
              Salin
            </button>
            <button
              type="button"
              data-testid={`monev-tautan-buka-${code}`}
              onClick={buka}
              className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-xs font-semibold text-slate-600 transition-colors duration-150 hover:bg-[#F3F7FB] hover:text-[#1479BF]"
            >
              <ExternalLink aria-hidden="true" className="h-3.5 w-3.5" />
              Buka
            </button>
          </div>
        </>
      )}
    </div>
  );
}
